// extracted by mini-css-extract-plugin
export default {"container":"Links_container__7sbIa","containerForLinks":"Links_containerForLinks__h1Op9"};